import { Navigate, useLocation } from "react-router-dom";
import Footer from "../common/footer";
import Header from "../common/header";
import Sidebar from "../common/sidebar";
import AccessDenied from "./AccessDenied";

// const PrivateRoute = ({ children }) => {
//   const loggedIn = localStorage.getItem("_token");

//   return loggedIn ? (
//     <>
//       <Sidebar />
//       <Header />
//       {children}
//       <Footer />
//     </>
//   ) : (
//     <Navigate to="/login" />
//   );
// };

const PrivateRoute = ({ children, role }) => {
  const loggedIn = localStorage.getItem("_token");
  const userData = JSON.parse(localStorage.getItem("userData"));
  const tokenRole = userData?.[0]?.role;
  const location = useLocation();

  const userHasRequiredRole = role === tokenRole ? true : false;

  if (!loggedIn) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  if (loggedIn && !userHasRequiredRole) {
    return <AccessDenied />;
  }

  return (
    <>
      <Sidebar />
      <Header />
      {children}
      <Footer />
    </>
  );
};
export default PrivateRoute;
